import { Dialog, styled } from "@mui/material";

const DialogComponentStyled = styled(Dialog)({
    "& .MuiDialogContent-root": {
        padding: "16px",
        border: 0,
    },
    ".MuiDialogTitle-root+.MuiDialogContent-root": {
        paddingTop: "16px",
    },
    "& .MuiDialogActions-root": {
        padding: "8px",
    },
    "& .MuiBackdrop-root": {
        background: "rgba(0, 0, 0, 0.4)",
        backdropFilter: "blur(6px)",
    },
    "& .MuiDialog-container .MuiPaper-root": {
        minWidth: "365px",
    },
});

export default DialogComponentStyled;
